/**
 * 情報活用コース情報クラス
 */
var PmlCourseInfo = /** @class */ (function () {
    function PmlCourseInfo(props) {
        this.id = props.id;
        this.title = props.title;
        this.thumbnail = props.thumbnail;
    }
    return PmlCourseInfo;
}());
export { PmlCourseInfo };
